import { InjectionToken } from '@angular/core';

/** Sincroniza el estado de sesión del portal cuando el interceptor renueva o invalida el token. */
export interface AuthSessionHandler {
  setAccessToken(token: string): void;
  invalidate(): void;
}

export const AUTH_SESSION_HANDLER = new InjectionToken<AuthSessionHandler>('AUTH_SESSION_HANDLER');
